export default {
  meta: {
    'key-content': 'Бесплатный голосовой вызов, безопасная связь, мгновенные сообщения, запись после чтения, безопасное сообщение',
    'description-content': 'Crait - это инструмент безопасного обмена сообщениями и совместной работы, предназначенный для предприятий для повышения их производительности. Данные предприятия защищены от наблюдения или нарушения данных, поскольку данные транспортируются по зашифрованному каналу военного уровня.',
    'h-m-title': 'Crait | Ваша защищенная коммуникационная платформа'
  },
  head: {
    'home': 'Главная',
    'features': 'Особенности',
    'ценообразование': 'Ценообразование',
    'resources': 'Ресурсы',
    'openapi': 'открыто API',
    'контакт': 'Контакт',
    'download': 'Загрузить',
    'login': 'Вход в систему ',
    'console': 'Приставка ',
    'CraitForWeb': 'Crait для Интернета'
  },
  home: {
    'title1': 'Безопасное общение',
    'title2': 'Для всех',
    'subtitle': 'Безопасные чаты · Чтение и запись · Бесплатный аудио и видео звонок',
    'placeholder': 'Электронная почта, телефон или имя пользователя',
    'getstart': 'Начало работы',
    'contitle': 'Crait преимущество',
    'intro1-title': 'Поддержка чатов до 1000 человек',
    'intro1-detail': 'Поддержка создания групп на 1000 человек и конференц-связи с несколькими людьми, все сообщения, изображения и видео защищены сквозным шифрованием.',
    'intro2-title': 'Безопасная связь',
    'intro2-detail': 'Стандартное 256-битное шифрование AES для всех платформ. Чтобы предотвратить любую возможную атаку «человек-в-середине» и обеспечить безопасность данных, все сообщения проходят через Transport Layer Security (TLS).',
    'intro3-title': 'Оптимизация управления организацией',
    'intro3-detail': 'С административным контролем в программном обеспечении может быть встроена организационная структура, а сотрудники могут быть авторизованы для разных уровней данных.',
    'intro4-title': 'Предназначен для повышения эффективности',
    'intro4-detail': 'Secure Mail и зашифрованный Cloud Drive обеспечивают безопасность данных; Календарь устанавливает рабочие элементы и повышает эффективность работы',
    'keyfeature-title': 'Основные функции',
    'keyfeature-list1': 'Защищенные чаты',
    'keyfeature-list2': 'Безопасные звуковые вызовы',
    'keyfeature-list3': 'Безопасный общий доступ к файлам',
    'keyfeature-list4': 'Синхронизация по всем платформам',
    'keyfeature-list5': 'Голосовые сообщения',
    'keyfeature-list6': 'Безопасный облачный диск',
    'learnmore': 'Подробнее',
    'download-title': 'Доступно для загрузки на всех популярных платформах',
    'download-detail': 'Crait - это то, где рабочие группы взаимодействуют и взаимодействуют безопасно. Это безопасный инструмент обмена сообщениями, предназначенный для повышения эффективности и продуктивности работы. Доступные на разных платформах сообщения и данные могут синхронизироваться между всеми вашими устройствами.',
    'err-tip-email': 'Извините, но адрес электронной почты неверен',
    'err-tip-phone': 'Извините, но номер телефона неверен',
    'click': 'Нажмите значок',
    'wx-tip1': 'в правом верхнем углу',
    'select': 'Нажмите',
    'wx-tip2': 'чтобы открыть в браузере'
  },
  features: {
    'f-title': 'инструмент для безопасного обмена сообщениями, облегчающий работу.',
    'feature-title': 'Безопасное общение',
    'feature-list1-title': 'Защищенные чаты',
    'feature-list1-detail': 'от 1 до 1 чата и группового чата до 1000 пользователей. Передать, вызвать и удалить доступные параметры сообщения.',
    'feature-list2-title': 'Защищенные звуковые вызовы',
    'feature-list2-detail': '1 к 1 аудиовызову и групповому звуковому вызову до 20 пользователей. Функция отключения звука позволяет отключить фоновый шум.',
    'feature-list3-title': 'Конференц-связь',
    'feature-list3-detail': 'Наслаждайтесь сквозными зашифрованными конференц-вызовами с автоматическим прожектором для 20 пользователей. Функция автоматического прожектора усиливает голос основного динамика, наряду с функцией шумоподавления.',
    'feature-list4-title': 'Синхронизация по всем платформам',
    'feature-list4-detail': 'Доступно для всех основных платформ.',
    'feature-list5-title': 'Голосовые заметки',
    'feature-list5-detail': 'Нажмите, чтобы записать голосовое сообщение и отпустить, чтобы закончить запись и отправить.',
    'feature-list6-title': 'Безопасный общий доступ к файлам',
    'feature-list6-detail': 'Почти все поддерживаемые типы файлов, включая PDF-файлы, DOC, XLS и т. д. Документы объемом до 100 МБ могут совместно использоваться, а рабочие группы могут совместно работать над документом.',
    'feature-list7-title': 'Безопасный облачный диск',
    'feature-list7-detail': 'Безопасный персональный диск на основе облачных вычислений, обеспечивающий доступ к документам на ходу без каких-либо физических устройств.',
    'feature-list8-title': 'передача',
    'feature-list8-detail': 'Широковещательные сообщения распространяются на предварительно выбранные члены рабочей группы. Передача и прием передаются сразу. Эта функция полезна для экономии времени и может быть очень полезна для решения неотложных вопросов.',
    'feature-list9-title': 'Безопасность',
    'feature-list9-detail': 'Параметры записи и чтения, считывание настроек приема и функции защиты от скриншотов встроены в платформу.',
    'other-feature': 'Другие функции',
    'other-list1-title': 'Настраиваемые подключаемые приложения',
    'other-list1-detail': 'Приложения для плагинов могут быть настроены на основе ваших потребностей отрасли или конкретных потребностей компании. Благодаря обмену календарями команд, резервированию конференц-залов в управлении офисными поставками, эти приложения станут инструментом коммуникации, который поможет вам повысить эффективность работы и производительность.',
    'other-list2-title': 'Поиск',
    'other-list2-detail': 'Поиск по темам сообщений, чтобы найти старые сообщения. Легко находить контакты путем поиска по их адресам электронной почты или если у вас есть особые привилегии группового чата, назначенные администратором, поиск по группам для контактов. '
  },
  pricing: {
    'p-title1': 'Особенности',
    'p-title2': 'Crait',
    'p-title3': 'Crait Pro',
    'unlimited': 'неограниченный',
    'tr1-td1': 'Максимальное количество групп позволяет создавать',
    'tr2-td1': 'Максимальное количество членов группы',
    'tr3-td1': 'Максимальное количество получателей широковещательных сообщений',
    'tr4-td1': 'Максимальное количество участников конференции',
    'tr5-td1': 'Облачное пространство для группы',
    'tr6-td1': 'Облачное пространство для личных',
    'tr7-td1': 'Видеозвонок',
    'tr8-td1': 'Список подключаемых модулей',
    'tr8-td2': 'Только демонстрации сервера',
    'tr8-td3': 'Зарядка для каждого подключаемого модуля',
    'tr9-td1': 'Обслуживание и техническая поддержка клиентов',
    'tr9-td2': 'В App Support',
    'tr9-td3': '7x24h (почта или телефон)',
    'tr10-td1': 'Предоставляет веб-сайт или приложение Team Manager',
    'tr11-td1': 'Поддерживает все платформы',
    'tr12-td1': 'Ценообразование',
    'tr12-td2': 'бесплатно',
    'tr12-td3': '$ 2,99 в месяц',
    'btn1': 'Начать',
    'btn2': 'Обновить сейчас '
  },
  resources: {
    'readmore1': 'ПОДРОБНЕЕ -',
    'readmore2': 'Подробнее',
    'r-title1': 'Белая бумага',
    'r-title2': 'Блоги',
    'subtitle1': 'ЧТО ТАКОЕ CRAIT?',
    'detail1': 'Crait - это безопасная связь и сотрудничество. Это безопасный инструмент обмена сообщениями, предназначенный для упрощения и повышения эффективности работы рабочих групп ...',
    'subtitle2': 'Тенденции нарушения данных',
    'detail2': 'Нарушения данных не являются хорошими. Он будет хорошо обслуживать компании, чтобы пересмотреть свою основную гигиену безопасности с преднамеренным взглядом на укрепление своих соответствующих постов безопасности ...',
    'subtitle3': 'Маленькие предприятия - это легкие цели',
    'detail3': 'Не все здравые мысли содержат воду. Одним из примеров общепринятой идеи, которая не соответствует действительности, является то, что хакеры нацелены только на крупные компании. Возрастающее число кибератак на малые предприятия сильно противоречит этому, казалось бы, преобладающему настрою, что малые предприятия не являются объектом хаков. Давайте рассмотрим факты ... '
  },
  contact: {
    'c-title1': 'Спасибо за ваш интерес к защищенной платформе связи Crait',
    'c-title2': ', пожалуйста, сообщите нам больше о вашей компании, и наша команда по продажам вскоре свяжется с вами',
    'firstname': 'Имя *',
    'lastname': 'Фамилия *',
    'workemail': 'Work Email *',
    'phone': 'Номер телефона *',
    'company': 'Название компании *',
    'size': 'Размер компании *',
    'location': 'Местоположение',
    'industry': 'Промышленность',
    'send': 'Отправить',
    // 'address':'Address: 5005 Newport Drive, Suite 510 Rolling Meadows, IL',
    // 'zipcode':'Почтовый индекс: 60008',
    // 'tel':'Tel: (847) 873-1567',
    'emaillabel': 'Email:',
    'email': 'info@craitapp.com '
  },
  download: {
    'intro': 'Crait - это то, где рабочие группы взаимодействуют и взаимодействуют безопасно. Это безопасный инструмент обмена сообщениями, предназначенный для повышения эффективности и продуктивности работы. Доступные на разных платформах сообщения и данные могут синхронизироваться между всеми вашими устройствами.',
    'd-title': 'Доступно для загрузки на всех популярных платформах',
    'sub-intro1': 'Чтобы установить Crait, сканируйте QR ниже или нажмите кнопки ниже.',
    'sub-intro2': 'Вы также можете войти в Crait для доступа к веб-версии',
    'home-download-title1': 'Управление командой для предприятий',
    'home-download-title2': 'Эффективный организационный дизайн',
    'home-download-title3': 'почта',
    'home-download-title4': 'Конференц-связь',
    'home-download-title5': 'иди к crait веб -',
    'home-download-title6': 'загрузить crait для пк',
    'home-download-title7': 'попробуйте crait сейчас',
    'home-download-title8': 'облачный накопитель',
    'download-getApp': 'Получите приложение для ',
    'download-iphone': 'iPhone',
    'download-scanCode': 'Скачайте приложение',
    'download-dlApp': 'для загрузки кода',
    'download-gphone': 'Android',
    'download-pc': 'PC',
    'download-chrome': 'Chrome',
    'download-title-m': 'Безграничное сотрудничество',
    'download-dl-btn': 'Начать'
  },
  payment: {
    'prices-payment-title1': 'счет, который будет повышен',
    'prices-payment-title2': 'счет, на который вы хотите получить crait Pro',
    'prices-payment-title3': 'план, вы хотите купить',
    'prices-payment-title4': 'пожалуйста, выберите',
    'prices-payment-title5': 'в общей сложности',
    'prices-payment-title6': 'выплаты',
    'prices-payment-title7': 'PayPal',
    'prices-payment-title8': 'заплачу',
    'prices-payment-title9': 'до crait Pro означает, что вы согласны со следующими условиями',
    'prices-payment-title10': 'crait заплатил пользовательского соглашения',
    'prices-payment-title11': 'политика конфиденциальности',
    'prices-payment-title12': 'ошибка сети!',
    'prices-payment-title13': 'пожалуйста, введите зарегистрированное crait счета'

  },
  confirm: {
    'prices-confirm-title1': 'счет, который будет повышен',
    'prices-confirm-title2': 'выбрал план',
    'prices-confirm-title3': 'в общей сложности',
    'prices-confirm-title4': 'выплаты',
    'prices-confirm-title5': 'оплатить',
    'prices-confirm-title6': 'собираюсь третьей стороне страницу оплаты.',
    'prices-confirm-title7': 'просьба сделать платеж в третьей стороне.',
    'prices-confirm-title8': 'не платить',
    'prices-confirm-title9': 'выплаты',
    'prices-confirm-title10': 'ошибка сети!'

  },
  success: {
    'prices-success-title1': 'твой счет был повышен до crait Pro',
    'prices-success-title2': 'ваш счет будет повышен до crait Pro, как только мы подтвердили выплату',
    'prices-success-title3': 'модернизация счета:',
    'prices-success-title4': 'план приобрел'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/rus.js